import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { fetchMips, getQualityMips } from '../../../../../helper/mipsHelper'
import { setMipsMeasures } from '../../../../../redux/sidePanel/sidePanelSlice'
import { changeMIPSdata } from '../../../../../redux/progressNote/progressNoteSlice'

// we want the store to save constantly, BUT we dont want repetitive spam save visit calls
// so the debounce only calls every 500ms to tell the store to save to the DB
const mipsDebounce = debounce((onSuccessFunc) => {
  onSuccessFunc()
}, 750)

const getMips = (mipsData, onSuccess) => {
  mipsDebounce(() => {
    fetchMips(mipsData, false).then((res) => {
      if (res) {
        onSuccess(res)
      }
    })
  })
}

async function checkMips({ encounterId, practiceId, dispatch, mips }) {
  mipsDebounce(() => {
    getQualityMips(encounterId, practiceId).then((newMips) => {
      dispatch(
        setMipsMeasures({
          mips: newMips,
          useLastAnswers: mips.length !== newMips.length || mips?.some((mip) => mip.value),
        }),
      )
      dispatch(
        changeMIPSdata(
          newMips.map((mip) => {
            // Notes require the MIPS value to be the label string
            return { ...mip, value: mip?.value?.label }
          }),
        ),
      )
    })
  })
}

export default function PanelMipsListener() {
  const dispatch = useDispatch()
  const practiceId = useSelector((state) => state?.user?.practice?._id)

  const encounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const isLastEncounter = useSelector((state) => state.sidePanel.isLastEncounter)
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)
  const panelMipsError = useSelector((state) => state.sidePanel.panelMipsError)
  const mips = useSelector((state) => state.sidePanel.panelMipsMeasures)

  useEffect(() => {
    if (practiceId) {
      if (!isLastEncounter && encounterId) {
        checkMips({ encounterId, practiceId, dispatch, mips })
      } else {
        getMips(
          {
            practice_id: practiceId,
            charge_id: null,
            service_date: panelEncounter.service_date_from,
            patient: {
              id: panelEncounter?.patient_id,
              dob: panelEncounter?.patient_dob,
              gender: panelEncounter?.gender,
              hospiceEnrolled: Boolean(panelEncounter?.patient_hospiceEnrolled),
            },
            procedures: (panelEncounter?.procedureCodes || []).map((proc) => ({
              code: proc.code + '' || '',
              modifiers: proc.modifiers || [],
              units: proc?.units,
            })),
            diagnoses: (panelEncounter?.diagnosisCodes || []).map((item) => ({ code: item.code })),
            telehealth: panelEncounter?.telehealth,
            place_of_service: {
              code: panelEncounter?.place_of_service,
            },
          },
          (newMips) => {
            dispatch(setMipsMeasures({ mips: newMips, useLastAnswers: true }))
          },
        )
      }
    }
    // panelMipsError helps us with a race condition of mips updating
  }, [encounterId, practiceId, isLastEncounter, panelEncounter, panelMipsError])

  return null
}
